<template>
  <v-dialog
    v-model="display"
    width="450"
  >
    <v-card
      color="white"
    >
      <v-progress-linear
        v-if="countdown > 0"
        color="error"
        height="40"
        style="margin: 0 !important;"
        :value="(60 - (countdown || 60)) / 0.6"
      ></v-progress-linear>
      <v-card-text v-if="countdown > 0">
        <span style="font-weight:500;font-size:24px;">Are you still there?</span><br />
        For security, {{ app_name }} will log you out in {{ countdown }} seconds.<br/><br/>
        To stay logged in, move your mouse, tap your screen, or press any key.<br /><br />
      </v-card-text>
      <v-card-text
        v-else
        style="text-align:center;padding-top:35px;"
      >
        <div
          style="margin:auto;width:100%"
        >
          <v-icon
            size="64"
            color="black"
          >
            lock
          </v-icon>
        </div>
        <br />
        <span style="font-weight:500;font-size:24px;">You have been logged out.</span><br />
        For security, {{ app_name }} logged you out due to inactivity.<br/><br/>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      display: true,
      interval: null,
      countdown: 60,
      previousTitle: ''
    }
  },
  watch: {
    countdown () {
      if (this.countdown <= 0) {
        clearInterval(this.interval)
        this.logOutAction()
      }
      if (!this.countdown) {
        this.documentTitle(this.previousTitle)
        clearInterval(this.interval)
      }
    }
  },
  created () {
    this.interval = setInterval(() => {
        this.timerCount()
    }, 1000)
    this.previousTitle = document.title.split('|')[1]
  },
  beforeDestroy () {
    this.documentTitle(this.previousTitle)
    clearInterval(this.interval)
  },
  methods: {
    ...mapActions('auth', {
      logOutAction: 'logOut'
    }),
    timerCount () {
      this.countdown -= 1
      document.title = "Are you still there? (" + this.countdown + ") | " + this.app_name
    }
  }
}
</script>
